import React from 'react';
import { useIsMobileLayout } from '../../hooks/useIsMobileLayout';
import Button from './Button';
import { getIntl } from '../../utils/intl';
import { useProfilesTabNavigation } from '../../utils/appNavigationNames';
import IconButton from './IconButton';
import useRecordEvent from '../../hooks/useRecordEvent';

const intl = getIntl('AIChatButton', {
    buttonTitle: 'Ask our Assistant',
});

export type AIChatButtonOwnProps = {
    useNestedNavigation: boolean;
    medicalProfileId: string;
};

export type AIChatButtonProps = AIChatButtonOwnProps;

const AIChatButton: React.FC<AIChatButtonProps> = ({ medicalProfileId }) => {
    const isMobile = useIsMobileLayout();
    const profilesTabNavigation = useProfilesTabNavigation();
    const record = useRecordEvent();

    return isMobile ? (
        <IconButton
            icon="AISparkle"
            onPress={() => {
                record('pressAssistantButton');
                profilesTabNavigation.navigate('chat', {
                    profileId: medicalProfileId,
                });
            }}
            testID="ai-chat-button"
        />
    ) : (
        <Button
            variant="secondary"
            title={intl('buttonTitle')}
            icon="AISparkle"
            onPress={() => {
                profilesTabNavigation.navigate('chat', {
                    profileId: medicalProfileId,
                });
            }}
            testID="ai-chat-button"
        />
    );
};

export default React.memo(AIChatButton);
